const area1 = require("../../assets/images/FlowAssurance2.jpeg");
const area2 = require("../../assets/images/ProcessEngineering2.jpeg");
const area3 = require("../../assets/images/Drafting2.jpeg");


const AreasOfWork = [


  {
    name: "Flow Assurance",
    image: area1,
    url: "/business",
    id: "#flow",
  },
  {
    name: "Process Engineering Support",
    image: area2,
    url: "/business",
    id: "#process",
  },

  
];

export default AreasOfWork;
